import type { ConvertedImage } from "../types";

const MAX_EDGE = 1600;
const QUALITY = 0.82;

export async function convertToWebp(files: FileList | File[]): Promise<ConvertedImage[]> {
  const selected = Array.from(files).slice(0, 5);
  const converted: ConvertedImage[] = [];

  for (const file of selected) {
    if (!file.type.startsWith("image/")) {
      throw new Error(`ไฟล์ ${file.name} ไม่ใช่รูปภาพ`);
    }

    const bitmap = await createImageBitmap(file);
    const scale = Math.min(1, MAX_EDGE / Math.max(bitmap.width, bitmap.height));
    const width = Math.max(1, Math.round(bitmap.width * scale));
    const height = Math.max(1, Math.round(bitmap.height * scale));
    const canvas = document.createElement("canvas");
    canvas.width = width;
    canvas.height = height;
    const context = canvas.getContext("2d");
    if (!context) throw new Error("ไม่สามารถแปลงรูปภาพได้");
    context.drawImage(bitmap, 0, 0, width, height);
    bitmap.close();

    const blob = await new Promise<Blob>((resolve, reject) => {
      canvas.toBlob(
        (result) => {
          if (!result) reject(new Error("เบราว์เซอร์ไม่รองรับการแปลง WebP"));
          else resolve(result);
        },
        "image/webp",
        QUALITY,
      );
    });

    const baseName = file.name.replace(/\.[^.]+$/, "") || "product";
    const webpFile = new File([blob], `${baseName}.webp`, { type: "image/webp" });
    converted.push({
      file: webpFile,
      previewUrl: URL.createObjectURL(webpFile),
      originalName: file.name,
    });
  }

  return converted;
}
